import React from 'react';
import { Paper, Box, Typography } from '@mui/material';
import { colors } from '../constants';

/** Compact KPI card with an icon, label and value. */
export default function StatCard({ icon, label, value, color = colors.primary, onClick }) {
  return (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: `1px solid ${colors.border}`,
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        cursor: onClick ? 'pointer' : 'default',
        transition: 'box-shadow .2s',
        '&:hover': onClick ? { boxShadow: 3 } : undefined,
        height: '100%',
      }}
    >
      {icon && (
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: `${color}1a`,
            color,
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
      )}
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="h5" sx={{ fontWeight: 700, color: colors.navy, lineHeight: 1.2 }}>
          {value}
        </Typography>
        <Typography variant="body2" sx={{ color: colors.gray500 }} noWrap>
          {label}
        </Typography>
      </Box>
    </Paper>
  );
}
